import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { ModeloVehiculoCreateInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculoCreate.interface";
import { ModelosVehiculoInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculo.interface";
export async function ModeloVehiculoCreateAction(
  Modelo: ModeloVehiculoCreateInterface
): Promise<ApiResponse<ModelosVehiculoInterface>> {
  const { data } = await apiClient.post<ModelosVehiculoInterface>(
    "/gvModeloVehiculos",
    Modelo,
  );
  return {
    status: 200,
    data,
    message: "Modelo de vehículo creada correctamente",
  };
}
